import { render } from "./AdminBoxProduction.vue?vue&type=template&id=55180fb3&scoped=true"
import script from "./AdminBoxProduction.vue?vue&type=script&lang=js"
export * from "./AdminBoxProduction.vue?vue&type=script&lang=js"

import "./AdminBoxProduction.vue?vue&type=style&index=0&id=55180fb3&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55180fb3"]])

export default __exports__